import { render, staticRenderFns } from "./details-panel-placeholder.vue?vue&type=template&id=99424b56&scoped=true&"
import script from "./details-panel-placeholder.vue?vue&type=script&lang=ts&"
export * from "./details-panel-placeholder.vue?vue&type=script&lang=ts&"
import style0 from "./details-panel-placeholder.vue?vue&type=style&index=0&id=99424b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99424b56",
  null
  
)

export default component.exports